import ru from "./ru.js";
import kz from "./kz.js";
import mn from "./mn.js";
import kg from "./kg.js";

export default {
  ru,
  kz,
  mn,
  kg,
};
